module.exports = __webpack_public_path__ + "9788f41e/img/upload-icon.9179ae4e.svg";